/**
 * SCHEMAS: SCHOOL
 * Schémas de validation Zod pour les écoles
 */

import { z } from 'zod';

export const createSchoolSchema = z.object({
  name: z.string().min(1, "Le nom de l'école est requis"),
  postal_code: z.string().optional(),
  city: z.string().optional(),
  country: z.string().min(1, 'Le pays est requis'),
  type: z.string().optional(),
  positioning: z.string().optional(),
  address: z.string().optional(),
  notes: z.string().optional(),
  // Personne à contacter
  contact_first_name: z.string().optional(),
  contact_last_name: z.string().optional(),
  contact_email: z.string().email('Email invalide').optional().or(z.literal('')),
  contact_phone: z.string().optional(),
});

export const updateSchoolSchema = z.object({
  name: z.string().min(1, "Le nom de l'école est requis"),
  postal_code: z.string().optional(),
  city: z.string().optional(),
  country: z.string(),
  type: z.string().optional(),
  positioning: z.string().optional(),
  address: z.string().optional(),
  notes: z.string().optional(),
  // Personne à contacter
  contact_first_name: z.string().optional(),
  contact_last_name: z.string().optional(),
  contact_email: z.string().email('Email invalide').optional().or(z.literal('')),
  contact_phone: z.string().optional(),
});

export type CreateSchoolInput = z.infer<typeof createSchoolSchema>;
export type UpdateSchoolInput = z.infer<typeof updateSchoolSchema>;
